module.exports = __webpack_public_path__ + "63e00b2956e62116f188cf7ab34ce0de.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-regular.ttf
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9